(() => {
  const init = (root) => {
    if (root.dataset.dronesDirectoryReady === 'true') return;
    root.dataset.dronesDirectoryReady = 'true';

    const items = Array.from(root.querySelectorAll('[data-drones-item]'));
    const status = root.querySelector('[data-drones-results-status]');
    const searchForm = root.querySelector('[data-drones-search-form]');
    const searchInput = root.querySelector('[data-drones-search]');
    const clearButton = root.querySelector('[data-drones-search-clear]');
    const noResults = root.querySelector('[data-drones-no-results]');

    if (!items.length) return;

    const normalize = (value) => String(value || '').trim().toLowerCase();

    const applySearch = () => {
      const query = normalize(searchInput?.value);
      let visible = 0;

      items.forEach((item) => {
        const card = item.querySelector('[data-search]');
        const searchableText = normalize(card?.dataset.search || '');
        const show = !query || searchableText.includes(query);

        item.hidden = !show;
        if (show) visible += 1;
      });

      if (status) {
        const searchStatus = query ? ` matching “${searchInput.value.trim()}”` : '';
        status.textContent = `${visible} ${visible === 1 ? 'item' : 'items'}${searchStatus}, newest first`;
      }
      if (clearButton) clearButton.hidden = !query;
      if (noResults) noResults.hidden = visible !== 0;
    };

    searchForm?.addEventListener('submit', (event) => event.preventDefault());
    searchInput?.addEventListener('input', applySearch);
    clearButton?.addEventListener('click', () => {
      searchInput.value = '';
      applySearch();
      searchInput.focus();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sw-drones-directory]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
